// extracted by mini-css-extract-plugin
export default {"Header":"Intro_Header__5kFw9","Text":"Intro_Text__31P0d"};